import { reduxForm } from 'redux-form';

import ClientForm from './ClientForm';

export default reduxForm({ form: 'clientForm' })(ClientForm as any) as any;
